import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=c48a63fa&scoped=true&lang=pug"
import script from "./FormLabel.vue?vue&type=script&lang=ts"
export * from "./FormLabel.vue?vue&type=script&lang=ts"
import style0 from "./FormLabel.vue?vue&type=style&index=0&id=c48a63fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48a63fa",
  null
  
)

export default component.exports